export const PRIORITIZED_ORDERS_LIST = 'PRIORITIZED_ORDERS_LIST'
export const PRINTED_ORDERS_LIST = 'PRINTED_ORDERS_LIST'
export const DASHBOARD_SETTINGS = 'DASHBOARD_SETTINGS'
export const LOCAL_PRINTER = 'LOCAL_PRINTER_DEPRECATED'